export default __webpack_public_path__ + "static/media/315.e4acf81b.png";